function handleTextTruncation() {
    try {
        var outerContainerId = 'blink-collection-pad';
        var textContainerId = 'blink-collection-desc';
        var breakpoint = 1024;
        var moreSelector = '.blink-more';
        var lessSelector = '.blink-less';
        var limit = 10;

        var outercontainer = document.getElementById(outerContainerId);
        var container = document.getElementById(textContainerId);
        var originalText = container.innerHTML;
        var text = originalText.split(' ');
        var moreLink = document.querySelector(moreSelector);
        var lessLink = document.querySelector(lessSelector);




      
function truncate() {
    var limitedText = '';
    if (window.innerWidth <= breakpoint) {
        var node = container.cloneNode(true);
        var words = node.textContent.split(' ');
        if (words.length > limit) {
            var currentWords = 0;
            var newText = document.createElement('div');
            var ellipsisAdded = false;
            for (var child of node.childNodes) {
                if (currentWords >= limit) break;
                if (child.nodeType === 3) { // Text node
                    var childWords = child.textContent.split(' ');
                    if (currentWords + childWords.length > limit) {
                        child.textContent = childWords.slice(0, limit - currentWords).join(' ');
                        currentWords = limit; // to prevent more words from being added
                        if (!ellipsisAdded) {
                            child.textContent += '...';
                            ellipsisAdded = true;
                        }
                    } else {
                        currentWords += childWords.length;
                    }
                } else if (child.nodeName === 'A') { // Anchor tag
                    var childWords = child.textContent.split(' ');
                    if (currentWords + childWords.length <= limit) {
                        currentWords += childWords.length;
                    } else {
                        child.textContent = childWords.slice(0, limit - currentWords).join(' ');
                        currentWords = limit; // to prevent more words from being added
                    }
                }
                newText.appendChild(child.cloneNode(true));
                if (currentWords >= limit && !ellipsisAdded) {
                    var ellipsisNode = document.createTextNode("...");
                    newText.appendChild(ellipsisNode);
                    ellipsisAdded = true;
                }
            }
            limitedText = newText.innerHTML;
            container.innerHTML = limitedText;
            moreLink.style.display = 'inline';
            lessLink.style.display = 'none';
            outercontainer.style.display = 'block';
        }
    } else {
        container.innerHTML = originalText;
        moreLink.style.display = 'none';
        lessLink.style.display = 'none';
        outercontainer.style.display = 'block';
    }
}









      

        moreLink.onclick = function(e) {
            e.preventDefault();
            container.innerHTML = originalText;
            moreLink.style.display = 'none';
            lessLink.style.display = 'inline';
        }

        lessLink.onclick = function(e) {
            e.preventDefault();
            truncate();
        }

        window.onload = truncate;
        window.onresize = truncate;
        
      
    } catch (error) {
      if(container){
        container.innerHTML = originalText;
        moreLink.style.display = 'none';
        lessLink.style.display = 'none';
        outercontainer.style.display = 'block';
      }
      
    }
}

handleTextTruncation();
